@if (isVisible) {
  <div class="status-message-dialogue">
    <div class="status-techn-wrapper">
      <div class="status-message" [innerHTML]="messageText"></div>
    </div>
    <div class="frame-parent">
      <div class="ok-wrapper">
        <div class="ok">OK</div>
      </div>
      <img class="iconclose" (click)="closeLink()" alt="" src="assets/img/toastclose.svg" width="12" height="13">
    </div>
    <div class="status-dialog" [ngClass]="messageType"></div>
  </div>
}
